import { render, staticRenderFns } from "./t-format-tags.vue?vue&type=template&id=71b5dbce"
import script from "./t-format-tags.vue?vue&type=script&setup=true&lang=ts"
export * from "./t-format-tags.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports